import { IFlexPanel } from '@bimser/components';
import { ReadonlyRecord } from '@bimser/core';
import { put, select, takeEvery } from 'redux-saga/effects';
import { WebInterfaceBaseState } from '../../common/base/state';
import { clickBreadCrumbItemAction } from '../actions';
import * as ActionTypesMain from '../actions/actionTypes';
import clickBreadCrumbItemAddAnimationCssAction from '../actions/clickBreadCrumbItemAddAnimationCssAction';
import clickBreadCrumbItemRemoveAnimationCssAction from '../actions/clickBreadCrumbItemRemoveAnimationCssAction';
import clickMaximizeFlexPanelAction from '../actions/clickMaximizeFlexPanelAction';
import hideFlexPanelOutLeftTransactionAction from '../actions/hideFlexPanelOutLeftTransactionAction';
import hideFlexPanelOutRightTransactionAction from '../actions/hideFlexPanelOutRightTransactionAction';
import resizeFlexPanelTransactionAction from '../actions/resizeFlexPanelTransactionAction';
import setActiveFlexPanelAction from '../actions/setActiveFlexPanelAction';
import showFlexPanelInLeftTransactionAction from '../actions/showFlexPanelInLeftTransactionAction';
import showFlexPanelInRightTransactionAction from '../actions/showFlexPanelInRightTransactionAction';
import getStateForSaga from './sagaHelper';

export default function* watchClickBreadCrumbTransaction() {
	yield takeEvery(ActionTypesMain.CLICK_BREADCRUMB_ITEM_TRANSACTION, clickBreadCrumbTransaction);
}

export function* clickBreadCrumbTransaction(sagaAction: any) {
	const state: WebInterfaceBaseState = yield select();
	let totalSize: number = 0;

	enum Direction {
		Left,
		Right
	}

	let animationDirection: Direction = Direction.Right;
	const _currentPanel = getStateForSaga(state).entities.find(x => x.id == sagaAction.payload.id);
	let currentPanel;
	if (_currentPanel) {
		currentPanel = _currentPanel.toJS();
	} else {
		return;
	}

	// Tıklanan panel aktif değilse işlem yap
	if (!currentPanel.isActive && (!currentPanel.isOnScreen || sagaAction.payload.isOnTheScreen)) {
		const showingPanels: Array<IFlexPanel> = [];

		//Startup panel boyutu 3'de sabittir. Resize olmaz pinlenen paneller ekrandan gider.
		const hidingPanels = getStateForSaga(state).entities.filter(
			x => x.isOnScreen && x.isVisible
		);
		let resizeVal: number = 0;

		//Tıklanan panelin indexini bul
		const currentPanelIndex = getStateForSaga(state).result.indexOf(currentPanel.id);

		//Önceki aktif panelin indexini bul
		const lastActivePanel = getStateForSaga(state).entities.find(x => x.isActive);
		let lastActivePanelIndex;
		if (lastActivePanel) {
			lastActivePanelIndex = getStateForSaga(state).result.indexOf(lastActivePanel.id);
		} else {
			lastActivePanelIndex = getStateForSaga(state).result.size;
		}

		// #region [Direction Hesaplama]
		if (currentPanelIndex < lastActivePanelIndex) {
			animationDirection = Direction.Left;
		}

		// ekranda görünmesi gereken panel listesini oluşturuyoruz.
		if (animationDirection == Direction.Left) {
			for (
				let index = currentPanelIndex;
				index <= getStateForSaga(state).result.size - 1;
				index++
			) {
				const panelId = getStateForSaga(state).result.get(index);
				if (panelId) {
					let panel = getStateForSaga(state).entities.get(panelId);

					// total siz değeri hesaplanıyor
					totalSize += panel.initialSize;

					if (!panel.disableResize) {
						// panel resize edilmişse initialSize değerini set ediyoruz
						// pinned item varsa ekranda, panelin kendisi de resize edilebilir.
						// ekrana gelicek panel startup panel ise özel durum oluşur.
						// ekranda pinned item yoksa tıklanan item orijinal size değerine set ediliyor.
						if (index == currentPanelIndex && panel.size != panel.initialSize) {
							yield resizePanel((panel = panel.set('size', panel.initialSize)));
						}

						// işlem yapılan panel ilk panel değilse resize işlemi gerekli mi kontrol edeceğiz.
						if (index > currentPanelIndex) {
							if (totalSize > 3 && resizeVal < 3) {
								yield resizePanel(
									(panel = panel.set('size', 3 - (totalSize - panel.initialSize)))
								);
							} else {
								if (panel.size != panel.initialSize) {
									yield resizePanel(
										(panel = panel.set('size', panel.initialSize))
									);
								}
							}
						}
					}

					// resize edilen panellerin size toplamı
					resizeVal += panel.size;

					if (resizeVal <= 3) {
						showingPanels.push(panel);
					} else {
						break;
					}
				}
			}
		} else {
			// Direction Right
			for (let index = currentPanelIndex; index >= 0; index--) {
				const panelId = getStateForSaga(state).result.get(index);
				if (panelId) {
					let panel = getStateForSaga(state).entities.get(panelId);

					// total siz değeri hesaplanıyor
					totalSize += panel.initialSize;

					if (!panel.disableResize) {
						// panel resize edilmişse initialSize değerini set ediyoruz
						// pinned item varsa ekranda, panelin kendisi de resize edilebilir.
						if (
							index == currentPanelIndex &&
							panel.size != panel.initialSize &&
							!panel.isStartupPanel
						) {
							yield resizePanel((panel = panel.set('size', panel.initialSize)));
						}
						// işlem yapılan panel ilk panel değilse resize işlemi gerekli mi kontrol edeceğiz.
						if (index < currentPanelIndex && !panel.isStartupPanel) {
							if (totalSize > 3 && resizeVal < 3) {
								yield resizePanel(
									(panel = panel.set('size', 3 - (totalSize - panel.initialSize)))
								);
							} else {
								if (panel.size != panel.initialSize) {
									yield resizePanel(
										(panel = panel.set('size', panel.initialSize))
									);
								}
							}
						}
					}

					// resize edilen panellerin size toplamı
					resizeVal += panel.size;

					if (resizeVal <= 3) {
						showingPanels.push(panel);
					} else {
						break;
					}
				}
			}
		}

		if (animationDirection == Direction.Left) {
			const resultPanels = getStateForSaga(state)
				.result.filter(x => hidingPanels.has(x))
				.toArray();
			for (let i = resultPanels.length - 1; i >= 0; i--) {
				const panel = hidingPanels.get(resultPanels[i]);
				if (panel.isOnScreen && panel.isVisible) {
					const mergedPanels = showingPanels.filter(x => x.id == panel.id);
					if (mergedPanels.length <= 0) {
						yield put(hideFlexPanelOutRightTransactionAction(panel));
					}
				}
			}

			for (let i = showingPanels.length - 1; i >= 0; i--) {
				const panel = showingPanels[i];
				if (!panel.isOnScreen && !panel.isVisible) {
					yield put(showFlexPanelInLeftTransactionAction(panel));
				}
			}
		} else {
			const resultPanels = getStateForSaga(state)
				.result.filter(x => hidingPanels.has(x))
				.toArray();
			for (let i = 0; i <= resultPanels.length - 1; i++) {
				const panel = hidingPanels.get(resultPanels[i]);
				if (panel.isOnScreen && panel.isVisible) {
					const mergedPanels = showingPanels.filter(x => x.id == panel.id);
					if (mergedPanels.length <= 0) {
						yield put(hideFlexPanelOutLeftTransactionAction(panel));
					}
				}
			}

			for (let i = 0; i <= showingPanels.length - 1; i++) {
				const panel = showingPanels[i];
				if (panel.isOnScreen) {
					continue;
				}
				if (!panel.isOnScreen && !panel.isVisible) {
					yield put(showFlexPanelInRightTransactionAction(panel));
				}
			}
		}

		// Tıklanan paneli aktif et
		yield put(setActiveFlexPanelAction(currentPanel.id));
		yield put(clickBreadCrumbItemAction(currentPanel));
		yield put(clickBreadCrumbItemAddAnimationCssAction(currentPanel));
		yield put(clickBreadCrumbItemRemoveAnimationCssAction(currentPanel));
	}
}

function* resizePanel(panel: ReadonlyRecord<IFlexPanel>) {
	yield put(resizeFlexPanelTransactionAction(panel));
	yield put(clickMaximizeFlexPanelAction(panel));
}
